import { useAuth, useTranslation } from '@/context/AuthContext';
import { useState, useEffect } from 'react';
import { getTrips } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Compliance() {
  const { families } = useAuth();
  const { t } = useTranslation();
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (families.length > 0) {
      getTrips(families[0].family_id).then(r => setTrips(r.data)).catch(() => {}).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [families]);

  if (loading) return <div className="h-48 bg-[#E2E8F0] rounded-2xl animate-pulse" />;

  return (
    <div className="space-y-6 animate-fade-in" data-testid="compliance-page">
      <h1 className="text-2xl md:text-3xl text-[#1E293B]" >
        {t('compliance.title')}
      </h1>

      {trips.length === 0 ? (
        <Card className="border border-[#E2E8F0]/40 rounded-2xl">
          <CardContent className="p-12 text-center">
            <ShieldCheck className="w-12 h-12 text-[#E2E8F0] mx-auto mb-4" strokeWidth={1} />
            <p className="text-sm text-[#64748B]">{t('common.noData')}</p>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-4">
          {trips.map(trip => (
            <Link key={trip.trip_id} to={`/trips/${trip.trip_id}`}>
              <Card className="border border-[#E2E8F0]/40 rounded-2xl hover:shadow-md transition-shadow cursor-pointer" data-testid={`compliance-trip-${trip.trip_id}`}>
                <CardContent className="p-5">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="font-medium text-[#1E293B]" >{trip.name}</h3>
                      <p className="text-xs text-[#64748B] mt-0.5">{trip.destination}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-lg font-bold text-[#1E293B]">{trip.compliance_ok || 0}/{trip.compliance_total || 0}</p>
                      <Badge variant={trip.compliance_ok === trip.compliance_total && trip.compliance_total > 0 ? 'default' : 'secondary'} className="text-[10px] rounded-full">
                        {trip.compliance_total === 0 ? t('common.noData') : trip.compliance_ok === trip.compliance_total ? t('compliance.valid') : t('compliance.pending')}
                      </Badge>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
